function groupByColor(colourArray) {
  const options = {}

  colourArray.each(function (i, el) {
    option = $(el).data('color');

    if (options.hasOwnProperty(option)) {
      options[option] += 1;
    }
    else {
      options[option] = 1;
    }
  })

  return options
}

$(window).on('load', function () {
  const products = $('.js-available-swatch-options')

  $.each(products, function (index, product) {
    const hasColor = $(product).data('has-color')
    const hasSize = $(product).data('has-size')
    const hasMaterial = $(product).data('has-material')
    const productId = $(product).data('product-id')

    if (!hasColor) {
      return
    }

    let numOption = 3

    if (hasColor && !hasSize && !hasMaterial) {
      numOption = 1
    } else if (hasColor && !hasSize && hasMaterial) {
      numOption = 2
    } else if (hasColor && hasSize && !hasMaterial) {
      numOption = 2
    }

    const hideColour = groupByColor($(`.js-hidden-pl-variant-options[data-is-hidden="true"][data-product-id="${productId}"]`))

    for (var key in hideColour) {
      if (hideColour[key] == numOption) {
        $(`.js-product-top-swatch-label[data-product-id="${productId}"][data-value="${key}"]`).hide()
      }
    }
  })
})
